/* unplugin-vue-components disabled */import { render } from "./SearchByType.vue?vue&type=template&id=c6abd670&ts=true"
import script from "./SearchByType.vue?vue&type=script&lang=ts"
export * from "./SearchByType.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__